/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

/*
 * @var values - object ot pass to method onBlur
 * @var name - of fild to edit
 * @method onBlur
 * @id is optional
 * */

import React, {Component, PropTypes} from 'react';
import {Input, Button} from '../../Common/reactstrap/lib';
import _ from 'lodash';
class EditableField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  editInput(e, data = false) {
    console.log(e, data);
    if (!e && data) {
      let upd = _.merge({},this.props.values, {[this.props.name]: data});
      if(this.props.id){
        this.props.onBlur(upd, this.props.id);
      }else{
        this.props.onBlur(upd);
      }

    }
    this.setState({
      inputToEdit: e
    });

  }

  handleInputChange(event) {
    const target = event.target,
      value = !target.value ? ' ' : target.value;

    this.setState({
      value
    });
  }

  render() {
    let {values, name, onBlur} = this.props,
      value = this.state.value && this.state.value.length != 0 ?  this.state.value : values[name];
    return (
      <div onClick={() => this.editInput(values)}>{
        !this.state.inputToEdit ? <Button color="link" className={this.props.classBtn || ''}>{value && value.length > 3 ?  value : this.props.placeholder }</Button> :
          <Input
            autoFocus={true}
            value={value}
            onBlur={() => this.editInput(false, value)}
            onChange={this.handleInputChange}
          />
      }
      </div>
    );
  }
}

export default EditableField;



/** WEBPACK FOOTER **
 ** ./src/components/Common/EditableField/index.jsx
 **/